'use strict';

/* eslint no-undef: "off" */
/**
 * add to cart api
 */
define('addToCartApi',['baseApiPost'], function (baseApiPost) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return baseApiPost('/rest/V1/xmapi/addtocart', params, { setCache: 'cart' });
  };
});
